(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"), require("jsonpath"));
	else if(typeof define === 'function' && define.amd)
		define(["axios", "jsonpath"], factory);
	else if(typeof exports === 'object')
		exports["Peace"] = factory(require("axios"), require("jsonpath"));
	else
		root["Peace"] = factory(root["_"], root["jsonpath"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_axios__, __WEBPACK_EXTERNAL_MODULE_jsonpath__) {
return 